// extracted by mini-css-extract-plugin
export var layoutContainer = "_b5-0";
export var layoutContainerNoRounding = "_b5-6";
export var layoutContainerOpen = "_b5-5";
export var layoutContainerResizing = "_b5-1";
export var mainContent = "_b5-2";
export var resizeDivider = "_b5-3";
export var slidePanel = "_b5-4";